/**
 * `/search?q=&type=` — the results page's address, shareable (brief 06).
 *
 * `type` survives only as one of the six groups; anything else is "All". `q` is kept as typed
 * and normalised where it is read, so a pasted address with a double space still searches.
 */

import { MAX_QUERY, SEARCH_GROUPS } from './api';
import type { SearchGroupKey } from './api';

export interface SearchRouteSearch {
  readonly q?: string;
  readonly type?: SearchGroupKey;
}

function isGroup(value: unknown): value is SearchGroupKey {
  return typeof value === 'string' && SEARCH_GROUPS.some((group) => group === value);
}

export function parseSearchRouteSearch(search: Record<string, unknown>): SearchRouteSearch {
  const q = typeof search.q === 'string' && search.q !== '' ? search.q.slice(0, MAX_QUERY) : undefined;
  const type = search.type;
  return {
    ...(q === undefined ? {} : { q }),
    ...(isGroup(type) ? { type } : {}),
  };
}
